import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { GlobalStyle } from './GlobalStyle';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { FeatureProvider, useFeatures } from './feature/FeatureContext';
import { AppConfig } from './config';
import { CustomThemeProvider } from './theme/ThemeContext';

// Importy komponentów
import LandingPage from './main/LandingPage';
import MainPage from './main/MainPage';
import LoginPage from './auth/LoginPage';
import RegisterPage from './auth/RegisterPage';
import OAuth2RedirectHandler from './auth/OAuth2RedirectHandler';
import TermsOfServicePage from './terms/TermsOfService';
import AcceptInvitationPage from './auth/AcceptInvitationPage';
import ClaimAccountPage from './auth/ClaimAccountPage';
import ProtectedRoute from './utils/ProtectedRoute';

// **KLUCZOWA ZMIANA: Komponent AppLayout jest teraz zdefiniowany wewnątrz App**
// Dzięki temu ma pewność, że wszystkie konteksty (Auth, Features) są już dostępne.
const AppLayout = () => {
    const { currentUser, isLoading: isAuthLoading } = useAuth();
    const { isLoading: isFeaturesLoading } = useFeatures();

    if (isAuthLoading || isFeaturesLoading) {
        return <div style={{textAlign: 'center', padding: '50px', fontSize: '1.2rem', fontFamily: 'sans-serif'}}>Ładowanie aplikacji...</div>;
    }

    return (
        <Routes>
            <Route path="/login" element={currentUser ? <Navigate to="/app" replace /> : <LoginPage />} />
            {AppConfig.auth.ENABLE_STANDARD_REGISTER && (
                <Route path="/register" element={currentUser ? <Navigate to="/app" replace /> : <RegisterPage />} />
            )}
            <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/accept-invitation/:token" element={<AcceptInvitationPage />} />
            <Route path="/claim-account" element={<ProtectedRoute><ClaimAccountPage /></ProtectedRoute>} />
            <Route path="/app/*" element={<MainPage />} />
            <Route path="/" element={currentUser ? <Navigate to="/app" replace /> : <LandingPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

function App() {
    return (
        <HelmetProvider>
            <Helmet>
                <title>{AppConfig.appName}</title>
                <meta name="description" content={`Aplikacja ${AppConfig.appName}`} />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
                <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;600;700&family=Comic+Neue:wght@400;700&family=Gaegu:wght@400;700&family=Manrope:wght@400;500;600;700&family=Patrick+Hand&family=Space+Grotesk:wght@400;600;700&display=swap" rel="stylesheet" />
            </Helmet>
            <Router>
                <AuthProvider>
                    <FeatureProvider>
                        <CustomThemeProvider>
                            <GlobalStyle />
                            <AppLayout />
                        </CustomThemeProvider>
                    </FeatureProvider>
                </AuthProvider>
            </Router>
        </HelmetProvider>
    );
}

export default App;